import { Box, Typography, Container } from '@mui/material';
import { useGlobalState } from "../contexts/GlobalState";
import { useEffect } from 'react';

export const HelpSupport = () => {
    const { setBreadcrumbsText } = useGlobalState();

    useEffect(() => {
        setBreadcrumbsText(["Home", "Help & Support"]);
    }, []);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography variant="h4" gutterBottom>
                    Help & Support
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    Help and support content will be available here.
                </Typography>
            </Box>
        </Container>
    );
};
